import React, { useState, useCallback, useEffect } from "react";
import {
  Page,
  Layout,
  Card,
  Text,
  Button,
  TextField,
  Switch,
  Thumbnail,
  InlineGrid,
  Tabs,
  Icon,
} from "@shopify/polaris";
import { useNavigate } from "react-router-dom";
import embed from "./icons/embed.png";
import toggle from "./icons/toggle-on-off.png";
import signup from "./icons/signup.png";
import referral from "./icons/referral_reward.png";
import referralSetting from "./icons/referral_settings.png";
import referralProgramLink from "./icons/referral_program_link.png";
import referralProgramLink2 from "./icons/referral_program_link2.png";
import referralCopyLink from "./icons/copylink.png";
import OrderAmountThreshold from "./icons/order_amount_threshold.png";
import seasonalPromotion from "./icons/seasonal_promotion.png";
import seasonalBanner from "./icons/seasonal_banner.png";
import promotionalBanner from "./icons/promotional_banner.png";
import enable from "./icons/enable_disable.png";
import firstOrder from "./icons/first_order.png";
import { ReactComponent as AppIcon } from "./icons/credup-icon.svg";

export default function HowToUse() {
  const navigate = useNavigate();
  const [selected, setSelected] = useState(0);
  const handleTabChange = useCallback(
    (selectedTabIndex) => setSelected(selectedTabIndex),
    []
  );
  const tabs = [
    {
      id: "how-to-use-details",
      content: "Details",
      // badge: <Icon source={ProductListIcon} tone="base" />,
      panelID: "how-to-use-details",
    },
    {
      id: "how-to-use-video",
      content: "Video",
      // badge: <Icon source={SettingsIcon} tone="base" />,
      panelID: "how-to-use-video",
    },
  ];

  const tabContent = [
    <>
      <Text variant="bodyLg" fontWeight="bold">
        To Enable Our App Features, You have first to enable our App embed block
      </Text>
      <br />
      <Text variant="bodyLg" fontWeight="regular">
        Steps:
      </Text>
      <Text variant="bodyLg" fontWeight="regular">
        1. Go to your themes, then click{" "}
        <span style={{ fontWeight: "600" }}>Customize.</span>
      </Text>
      <br />
      <Text variant="bodyLg" fontWeight="regular">
        2. Now Click on the{" "}
        <span style={{ fontWeight: "600" }}>'App embed'</span> Icon.
      </Text>
      <div>
        <img
          src={embed}
          alt="embed"
          size="medium"
          style={{ width: "2rem", height: "10rem", marginTop: "5px" }}
        />
      </div>
      <br />
      <Text variant="bodyLg" fontWeight="regular">
        3. After clicking, You will see a list of available App embed blocks.
        You will see our App embed block{" "}
        <span style={{ fontWeight: "600" }}>'Credup'</span>,<br /> Click on the
        toggle button and enable the toggle button.
      </Text>
      <div>
        <img
          src={toggle}
          alt="embed"
          size="medium"
          style={{ width: "15rem", height: "11rem", marginTop: "5px" }}
        />
      </div>
      <br />
      <Text variant="bodyLg" fontWeight="regular">
        4. Click <span style={{ fontWeight: "600" }}>Save</span> from the Top
        right of the Customizer page.
      </Text>
      <br />
      <Text variant="bodyLg" fontWeight="regular">
        5. Set the amount of credit to be awarded for different actions like
        <span style={{ fontWeight: "600" }}>
          {" "}
          first order, order amount threshold, signup stores, referral reward,
          seasonal promotions{" "}
        </span>{" "}
        and save settings.
      </Text>
      <br />
      <Text variant="bodyLg" fontWeight="regular">
        6. Go to the <span style={{ fontWeight: "600" }}>First Order</span>{" "}
        section, enter the desired credit amount to reward for this order, set
        an <span style={{ fontWeight: "600" }}>expiry date</span>, and then
        click <span style={{ fontWeight: "600" }}>Save</span> to apply the
        rewards.
      </Text>
      <div>
        <img
          src={firstOrder}
          alt="embed"
          size="medium"
          style={{ width: "40rem", height: "4rem", marginTop: "5px" }}
        />
      </div>
      <br />
      <Text variant="bodyLg" fontWeight="regular">
        7. To set up a <span style={{ fontWeight: "600" }}>signup</span> reward,
        enter the store credit amount under{" "}
        <span style={{ fontWeight: "600" }}>First Order</span>, specify an
        <span style={{ fontWeight: "600" }}> expiry date</span>, and click{" "}
        <span style={{ fontWeight: "600" }}>Save</span> to apply the reward.
      </Text>
      <br />
      <div>
        <img
          src={signup}
          alt="embed"
          size="medium"
          style={{ width: "40rem", height: "4rem", marginTop: "5px" }}
        />
      </div>
      <br />
      <Text variant="bodyLg" fontWeight="regular">
        8. To add <span style={{ fontWeight: "600" }}>referral rewards</span>,
        choose either <span style={{ fontWeight: "600" }}>Based on Signup</span>{" "}
        or
        <span style={{ fontWeight: "600" }}> Based on First Order,</span>
        enter the credit amount set an{" "}
        <span style={{ fontWeight: "600" }}>expiry date</span>, and click{" "}
        <span style={{ fontWeight: "600" }}>Save</span> to apply the reward.
      </Text>
      <br />
      <div>
        <img
          src={referral}
          alt="embed"
          size="medium"
          style={{ width: "40rem", height: "4rem", marginTop: "5px" }}
        />
      </div>
      <br />
      <Text variant="bodyLg" fontWeight="regular">
        9. Go to the <span style={{ fontWeight: "600" }}>Sections</span>, add
        the <span style={{ fontWeight: "600" }}>Referral Banner</span> section,
        and then click <span style={{ fontWeight: "600" }}>Save</span> in the
        top right corner of the Customizer page.
      </Text>
      <br />
      <div>
        <img
          src={referralSetting}
          alt="embed"
          size="medium"
          style={{ width: "13rem", height: "7rem", marginTop: "5px" }}
        />
      </div>
      <br />
      <Text variant="bodyLg" fontWeight="regular">
        10. Go to the online store to view the referral link.
      </Text>
      <br />
      <div>
        <img
          src={referralProgramLink}
          alt="embed"
          size="medium"
          style={{ width: "40rem", height: "4rem", marginTop: "5px" }}
        />
      </div>
      <br />
      <Text variant="bodyLg" fontWeight="regular">
        11. To get the referral link, click on the “View Referral Program”.
      </Text>
      <br />
      <div>
        <img
          src={referralProgramLink2}
          alt="embed"
          size="medium"
          style={{
            width: "40rem",
            height: "6rem",
            marginTop: "5px",
            marginBottom: "15px",
          }}
        />
      </div>
      <br />
      <Text variant="bodyLg" fontWeight="regular">
        12. After clicking the referral link, copy it to earn more credits.
      </Text>
      <br />
      <div>
        <img
          src={referralCopyLink}
          alt="embed"
          size="medium"
          style={{
            width: "12rem",
            height: "9rem",
            marginTop: "5px",
            marginBottom: "15px",
          }}
        />
      </div>
      <br />
      <Text variant="bodyLg" fontWeight="regular">
        13. To set an order amount threshold,{" "}
        <span style={{ fontWeight: "600" }}>first enter the Order Amount.</span>
        Then, specify the{" "}
        <span style={{ fontWeight: "600" }}>Credit Amount</span> to reward
        customers for surpassing a certain amount, such as 100, set an{" "}
        <span style={{ fontWeight: "600" }}>expiry date</span>, and click{" "}
        <span style={{ fontWeight: "600" }}>Save</span> to apply the reward.
      </Text>
      <br />
      <div>
        <img
          src={OrderAmountThreshold}
          alt="embed"
          size="medium"
          style={{
            width: "40rem",
            height: "4rem",
            marginTop: "5px",
            marginBottom: "15px",
          }}
        />
      </div>
      <br />
      <Text variant="bodyLg" fontWeight="regular">
        14. To set a{" "}
        <span style={{ fontWeight: "600" }}>seasonal promotion</span>, choose
        the desired <span style={{ fontWeight: "600" }}>date</span>, enter the
        credit amount, set an <span style={{ fontWeight: "600" }}>expiry</span>,
        add <span style={{ fontWeight: "600" }}>promotional banner</span> text,
        customize the
        <span style={{ fontWeight: "600" }}>size</span> and{" "}
        <span style={{ fontWeight: "600" }}>colors</span>, and click{" "}
        <span style={{ fontWeight: "600" }}>Save</span> to apply the reward.
      </Text>
      <br />
      <div>
        <img
          src={seasonalPromotion}
          alt="embed"
          size="medium"
          style={{
            width: "40rem",
            height: "4rem",
            marginTop: "5px",
            marginBottom: "15px",
          }}
        />
      </div>
      <br />
      <Text variant="bodyLg" fontWeight="regular">
        15. Go to App Embeds, and search for{" "}
        <span style={{ fontWeight: "600" }}>seasonal banner</span> App, Click on
        the toggle button and enable the toggle button.
      </Text>
      <br />
      <div>
        <img
          src={seasonalBanner}
          alt="embed"
          size="medium"
          style={{
            width: "12rem",
            height: "9rem",
            marginTop: "5px",
            marginBottom: "15px",
          }}
        />
      </div>
      <br />
      <Text variant="bodyLg" fontWeight="regular">
        16. Go to the online store to view the Promotional banner
      </Text>
      <br />
      <div>
        <img
          src={promotionalBanner}
          alt="embed"
          size="medium"
          style={{
            width: "40rem",
            height: "4rem",
            marginTop: "5px",
            marginBottom: "15px",
          }}
        />
      </div>
      <br />
      <Text variant="bodyLg" fontWeight="regular">
        17. You can <span style={{ fontWeight: "600" }}>enable</span> or{" "}
        <span style={{ fontWeight: "600" }}>disable</span> the credits as needed
        to control reward availability
      </Text>
      <br />
      <div>
        <img
          src={enable}
          alt="embed"
          size="medium"
          style={{
            width: "40rem",
            height: "5rem",
            marginTop: "5px",
            marginBottom: "15px",
          }}
        />
      </div>
      <br />
      {/* <Text variant="bodyLg" fontWeight="bold">
        How do we HIDE our app from the store?
      </Text>
      <br />
      <Text variant="bodyLg" fontWeight="regular">
        Go back again in App embed blocks, simply disable the toggle and Top
        right of the Customizer page
      </Text>
      <br /> */}
    </>,
    <>
      <div style={{ textAlign: "center", marginTop: "20px" }}>
        <Text variant="bodyLg" fontWeight="bold">
          Watch the Setup Video
        </Text>
        <br />
        {/* <video
          controls
          style={{ width: "100%", maxWidth: "800px", marginTop: "10px" }}
        >
          <source src={demoVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video> */}
        {/* Or embed a YouTube video */}
        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/kvCSPyVcMD4?si=WJ3lfriIEFDujmj6"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen
        ></iframe>
      </div>
    </>,
  ];
  return (
    <Page fullWidth>
      <Card>
        <div
          style={{
            marginBottom: "0px",
          }}
        >
          <div className="title-bar--style">
            <InlineGrid
              alignItems="start"
              columns="1fr auto 1fr 1fr  1fr 1fr 1fr 1fr 1fr 1fr 2fr"
            >
              <div
                style={{
                  position: "relative",
                  display: "flex",
                  top: "-2px",
                  justifyContent: "end",
                }}
              >
                <AppIcon />
              </div>
              <div style={{ position: "relative" }}>
                <Text as="h2" variant="headingLg">
                  CredUP HOW TO USE
                </Text>
              </div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div>
                {/* <Button
                variant="primary"
                size="medium"
                onClick={() => navigate("/")}
              >
                Plans
              </Button> */}
              </div>
              <div>
                {/* <Button
                variant="primary"
                size="medium"
                onClick={() => navigate("/how-to-use")}
              >
                How to use
              </Button> */}
              </div>
            </InlineGrid>
          </div>
          {/* <Button
          size="micro"
          variant="primary"
          onClick={() => navigate("/settings")}
        >
          Settings
        </Button> */}
          <div style={{ marginLeft: "5px" }}>
            {/* <Button
            size="micro"
            variant="primary"
            onClick={() => navigate("/")}
          >
            Plan
          </Button> */}
          </div>
        </div>
        <Tabs
          tabs={tabs}
          selected={selected}
          onSelect={handleTabChange}
          fitted
        />
        {tabContent[selected]}
      </Card>
    </Page>
  );
}
